import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { MAIN_MENU_TRANSLATION_KEY } from "../../../constants";
export default /*#__PURE__*/_defineProperty({}, MAIN_MENU_TRANSLATION_KEY, {
  CTA_INPUT_PHONE: 'Get advice',
  PHONE_REQUIRED: 'Phone number required',
  MAIN_MENU_PHONE_INPUT_THANKS_TITLE: 'Done!',
  MAIN_MENU_PHONE_INPUT_THANKS: 'We will be in touch with you very soon :)',
  MAIN_MENU_PHONE_INPUT_END: 'Finish'
});